import { useEffect, useState } from "react";
import { Gift, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

const STORAGE_KEY = "dss_lm_widget_dismissed_v1";

/** Floating bottom-right lead magnet teaser. Dismissed = remembered forever. */
export const LeadMagnetWidget = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const wasDismissed = window.localStorage.getItem(STORAGE_KEY) === "1";
    if (wasDismissed) {
      setDismissed(true);
      return;
    }
    const t = window.setTimeout(() => setVisible(true), 8000);
    return () => window.clearTimeout(t);
  }, []);

  // Hide on /free (they're already there) and /scan (already converting)
  if (dismissed || pathname === "/free" || pathname === "/scan") return null;

  const dismiss = () => {
    setVisible(false);
    setDismissed(true);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, "1");
    }
  };

  return (
    <div
      aria-hidden={!visible}
      // `inert` removes the whole subtree from the tab order while the
      // widget is faded out, so no focusable button stays reachable.
      {...(!visible ? { inert: "" as unknown as boolean } : {})}
      className={cn(
        "fixed bottom-4 right-4 z-40 max-w-xs transition-all duration-500",
        visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0 pointer-events-none",
      )}
    >

      <div className="relative bg-navy border border-gold/40 shadow-[0_20px_60px_-15px_hsl(var(--gold)/0.5)] p-4 md:p-5">
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          className="absolute top-2 right-2 h-7 w-7 inline-flex items-center justify-center text-silver hover:text-white transition-colors"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="inline-flex items-center gap-2 text-[9px] uppercase tracking-[0.25em] text-orange">
          <Gift className="h-3 w-3" /> Free · 3 Teasers
        </div>
        <div className="font-display uppercase text-white text-sm mt-2 leading-tight pr-6">
          Get the <span className="text-gradient-gold">MAKECHANGE</span> starter kit
        </div>
        <p className="text-silver text-xs mt-2 leading-relaxed">
          Playbook PDF + 7-day mini-course + free book chapter.
        </p>
        <Link
          to="/free"
          onClick={dismiss}
          className="mt-3 inline-flex items-center justify-center bg-cta text-white font-display uppercase tracking-[0.2em] text-[10px] px-4 py-2.5 w-full shadow-cta hover:brightness-110 transition-all"
        >
          Send It To Me
        </Link>
      </div>
    </div>
  );
};
